import { DateTime as DT } from 'luxon';
import type { ProductSetType } from '@econtractor/types';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import CopyTextWrapper from 'components/others/CopyTextWrapper';
import PriceAndPriceSale from 'components/others/PriceAndPriceSale';
import { useProductSet } from './context/ProductSetProvider';
import SetTableRowActions from './SetTableRowActions';

interface SetTableRowProps {
    productSet: ProductSetType;
    fetchSets: (force?: boolean) => Promise<void>;
    setEditSetId: (setId: number) => void;
}

const SetTableRow = ({ productSet, fetchSets, setEditSetId }: SetTableRowProps) => {
    const { auth } = useAuth();
    const { showUpdated } = useProductSet();
    const dt = DT.fromMillis(productSet?.setUpdated || 0).toFormat('dd.MM.yyyy');

    return (
        <tr>
            <td className="name">
                <h6
                    className="mb-1 text-break cursor-pointer"
                    onClick={() => setEditSetId(productSet.ID)}
                >
                    {productSet.setName || '-'}
                </h6>
                <p className="text-muted f-12 mb-0 my-1 text-break">{productSet.setDescription || '-'}</p>
            </td>
            <td className="vendor">
                <h6 className="mb-1 text-break text-truncate" title={productSet.categoryName || ''}>
                    {productSet.categoryName || '-'}
                </h6>
            </td>
            <td className="id">
                <code>{productSet.ID}</code>
            </td>
            <td className="article text-truncate">
                <CopyTextWrapper value={productSet.setArticle || ''}>
                    <span title={productSet.setArticle}>{productSet.setArticle}</span>
                </CopyTextWrapper>
            </td>
            {showUpdated ? <td className="updated">{dt}</td> : null}
            <td className="price text-truncate">
                <PriceAndPriceSale
                    price={productSet?.totalPrice}
                    priceSale={productSet?.totalPriceSale}
                />
            </td>
            {hasUserAccess(auth?.user, 'prodEdit') && (
                <td className="action">
                    <SetTableRowActions
                        productSet={productSet}
                        fetchSets={fetchSets}
                        setEditSetId={setEditSetId}
                    />
                </td>
            )}
        </tr>
    );
};

export default SetTableRow;
